<template>
    <div class="codics-aonaer-info-sys-web-footer">
        <div class="codics-aonaer-info-sys-web-footer-xc">
            <div class="codics-aonaer-info-sys-web-footer-xc-txt">全球食品工业首选综合服务商</div>
            <div class="codics-aonaer-info-sys-web-footer-xc-txt" style="font-size: 26px;top: 70px;">Global food
                industry preferred integrated service
                provider</div>
        </div>
        <div class="codics-aonaer-info-sys-web-footer-box">
            <div class="codics-aonaer-info-sys-web-footer-box-container">
                <div class="codics-aonaer-info-sys-web-footer-box-line">
                    <div class="codics-aonaer-info-sys-web-footer-box-container-item" v-for="(item, index) in tagList"
                        :key="index" v-html="item"></div>
                    <div class="codics-aonaer-info-sys-web-footer-box-container-item codics-aonaer-info-sys-web-footer-box-container-item2 iconfont"
                        style="float: right !important;" @click="scrollTop">&#xe625;&nbsp;返回顶部
                    </div>
                </div>
                <div class="codics-aonaer-info-sys-web-footer-box-line2">
                    <el-image class="codics-aonaer-info-sys-web-footer-logo"
                        src="https://cdn.bosscaigou.com/huayuan/img/logo.svg" fit="fill"></el-image>
                    <div class="codics-aonaer-info-sys-web-footer-info">Copyright © 2025. All rights reserved.&nbsp;奥纳尔
                        版权所有<br>鲁ICP备13020444号-2 <el-image src="https://cdn.bosscaigou.com/huayuan/map/jh.png"
                            style="height:13px;width:13px;display: inline-block;vertical-align: middle;margin-top: -3px;"
                            fit="fill"></el-image>&nbsp;鲁公网安备37169102000140号</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tagList: ['首页', '奥纳尔制冷', '华誉机械', '万市德', '飞斯智能', '耗邦邦', '集团新闻']
        }
    },
    methods: {
        scrollTop() {
            window.scroll(0, 0);
        }
    }
}
</script>

<style>
.codics-aonaer-info-sys-web-footer {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
}

.codics-aonaer-info-sys-web-footer-xc {
    height: 188px;
    width: 100%;
    position: relative;
    float: left;
    background: url('https://cdn.bosscaigou.com/huayuan/img/wh_bj.jpg');
    background-size: 100% 100%;
}

.codics-aonaer-info-sys-web-footer-xc-txt {
    height: 100px;
    width: fit-content;
    position: absolute;
    margin: auto;
    top: -36px;
    left: 0;
    right: 0;
    bottom: 0;
    line-height: 100px;
    font-size: 44px;
    font-weight: bolder;
    text-align: center;
    color: #FFF;
    user-select: none;
    -webkit-user-drag: none;
}

.codics-aonaer-info-sys-web-footer-box {
    height: 211px;
    width: 100%;
    position: relative;
    float: left;
    background: #2b2b2b;
}

.codics-aonaer-info-sys-web-footer-box-container {
    height: 100%;
    width: 100%;
    max-width: 1360px;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
}

.codics-aonaer-info-sys-web-footer-box-line {
    height: 100px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 100px;
    box-sizing: border-box;
    padding: 30px 0;
    border-bottom: 1px solid rgba(255, 255, 255, .2);
}

.codics-aonaer-info-sys-web-footer-box-container-item {
    height: 40px;
    width: fit-content;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 0 15px;
    color: rgba(255, 255, 255, .6);
    font-size: 14px;
    line-height: 40px;
    transition: .3s;
    cursor: pointer;
    user-select: none;
    -webkit-user-drag: none;
}

.codics-aonaer-info-sys-web-footer-box-container-item:hover {
    color: #FFF;
}

.codics-aonaer-info-sys-web-footer-box-line2 {
    height: 111px;
    width: 100%;
    position: relative;
    float: left;
    padding: 0 15px;
}

.codics-aonaer-info-sys-web-footer-logo {
    height: 58.6px;
    width: 120px;
    position: relative;
    float: left;
    top: 50%;
    transform: translateY(-50%);
}

.codics-aonaer-info-sys-web-footer-info {
    height: fit-content;
    width: fit-content;
    position: relative;
    float: right;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    color: rgba(255, 255, 255, .4);
    line-height: 22px;
}

@media (max-width: 768px) {
    .codics-aonaer-info-sys-web-footer-xc-txt {
        font-size: 20px !important;
    }

    .codics-aonaer-info-sys-web-footer-box-container-item {
        display: none;
    }

    .codics-aonaer-info-sys-web-footer-box-container-item2 {
        display: block !important;
        right: 50%;
        transform: translateX(50%);
        font-size: 16px;
    }

    .codics-aonaer-info-sys-web-footer-box-line {
        height: 80px;
        line-height: 80px;
        padding: 20px 0;
    }

    .codics-aonaer-info-sys-web-footer-logo {
        left: 50%;
        transform: translateX(-50%);
        top: 20px;
    }

    .codics-aonaer-info-sys-web-footer-box {
        height: 250px;
    }

    .codics-aonaer-info-sys-web-footer-box-line2{
        padding: 0;
    }

    .codics-aonaer-info-sys-web-footer-info{
        width: 100%;
        text-align: center;
        top: 60% !important;
    }
}
</style>